// Portal-based help tooltip — duplicated from BrokerTeamAnalyzer's HelpTip
// by design (the master prompt forbids cross-page component imports). Kept
// small enough that divergence is a non-issue.

import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';

export default function HelpTip({ text }) {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const ref = useRef(null);

  const update = () => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos({ x: r.left + r.width / 2, y: r.top });
  };
  const onEnter = () => { update(); setShow(true); };
  const onLeave = () => setShow(false);

  return (
    <span className="relative inline-flex align-middle ml-1.5">
      <span
        ref={ref}
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        onFocus={onEnter}
        onBlur={onLeave}
        tabIndex={0}
        data-testid="sns-helptip-trigger"
        className="w-4 h-4 rounded-full bg-slate-200 text-slate-600 text-[10px] font-bold flex items-center justify-center cursor-help hover:bg-[#2FA163] hover:text-white transition-colors"
      >
        ?
      </span>
      {show && typeof document !== 'undefined' && ReactDOM.createPortal(
        <div
          className="fixed z-[100] w-64 p-2.5 rounded bg-[#092825] text-white text-xs leading-snug shadow-xl pointer-events-none"
          style={{
            left: pos.x,
            top: pos.y - 10,
            transform: 'translate(-50%, -100%)',
          }}
        >
          {text}
          <span
            className="absolute left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[6px] border-t-[#092825]"
            style={{ top: '100%' }}
          />
        </div>,
        document.body,
      )}
    </span>
  );
}
